module.exports = __webpack_public_path__ + "img/msr.7567ea83.svg";